<template>
  <Dialog :common-dialog="true" :dialog-width="1200">
    <template v-slot:title> Attachments - {{ milestone.barcode }} </template>
    <template v-slot:body>
      <div v-if="loading" class="text-center" role="status">
        <v-progress-circular indeterminate color="cyan" />
        <p class="mt-2">Loading attachments...</p>
      </div>
      <v-alert v-else-if="loadError" type="error" outlined role="alert">
        Unable to load milestone attachments.
        <v-btn text small v-on:click="loadAttachments">Retry</v-btn>
      </v-alert>
      <Attachments
        v-else-if="getPermission('attachment:view')"
        :images="attachments"
        :parent="projectId"
        :is-page-loading="loading"
        type="project"
      />
    </template>
    <template v-slot:action>
      <v-btn
        depressed
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="$emit('close')"
      >
        Close
      </v-btn>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import Attachments from "@/view/pages/partials/Detail/Attachments.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import { GET } from "@/core/services/store/request.module";

export default {
  name: "milestones-attachment",
  mixins: [CommonMixin],
  components: { Dialog, Attachments },
  props: {
    projectId: { type: Number, required: true },
    milestone: { type: Object, required: true },
  },
  data() {
    return {
      attachments: [],
      loading: true,
      loadError: false,
      requestId: 0,
    };
  },
  mounted() {
    this.loadAttachments();
  },
  beforeDestroy() {
    this.requestId += 1;
  },
  methods: {
    loadAttachments() {
      const requestId = ++this.requestId;
      this.attachments = [];
      this.loading = true;
      this.loadError = false;
      return this.$store
        .dispatch(GET, { url: `project-file/${this.projectId}` })
        .then(({ data }) => {
          if (requestId !== this.requestId) return;
          this.attachments = data.filter(
            (file) =>
              Number(file.type) === 90 &&
              Number(file.parent) === Number(this.milestone.id)
          );
        })
        .catch((error) => {
          if (requestId !== this.requestId) return;
          this.loadError = true;
          this.logError(error);
        })
        .finally(() => {
          if (requestId === this.requestId) this.loading = false;
        });
    },
  },
};
</script>
